import styled from "styled-components";

const StyledWallpaperButton = styled.button`
    width: auto;
    height: 330px;
    width: 300px;
    background-color: transparent;
    border-radius: 20px;
    border: 2px solid #fff;
    overflow: hidden;
    background-color: white;
    

    img {
        width: auto;
        height: 100%; 
        max-height: 300px;
    }
`

export default StyledWallpaperButton;